// The map of a plan: its versions, the tiers born from each one, and from
// there the tasks.
//
// WHAT JOINS THE LEVELS, and it is not a route: `tiers.plan_version_id` says
// which version a tier came out of, and `tasks.tier_id` which tier a task
// belongs to. Core publishes no "tree of a plan", so the panel reads the tiers
// OF THE PROJECT and groups them by version here.
//
// A TIER STAYS UNDER THE VERSION IT WAS BORN FROM. That is the whole rule of
// T01: approving v2 does not move what came out of v1, and a map that hung
// every tier off the newest version would be drawing the opposite.
//
// Versions come newest first from Core, and so does this map: the last thing
// somebody wrote is what they are looking for.

export function buildPlanMap(planDetail, tiers = []) {
    const plan = planDetail?.plan ?? planDetail ?? null;
    const versions = planDetail?.versions ?? plan?.versions ?? [];

    const byVersion = new Map(versions.map(version => [String(version.id), []]));
    const orphans = [];

    for (const tier of tiers) {
        const key = tier.plan_version_id == null ? null : String(tier.plan_version_id);
        // A tier of ANOTHER plan of the same project is not in this map, and a
        // legacy tier — born before canonical planning — hangs off no version.
        // Counted apart rather than filed under a version it never had.
        if (key && byVersion.has(key)) byVersion.get(key).push(tier);
        else if (!key) orphans.push(tier);
    }

    const sortTiers = list => [...list].sort((a, b) => (
        (a.sort_order ?? 0) - (b.sort_order ?? 0) || a.id - b.id
    ));

    return {
        plan,
        versions: versions.map(version => ({
            ...version,
            tiers: sortTiers(byVersion.get(String(version.id)) ?? []),
        })),
        // Legacy tiers of this project: shown once, at the foot, so they are not
        // invisible and not attributed either.
        legacy: sortTiers(orphans),
    };
}

// What the map says about a version at a glance: how many tiers it produced.
export function countTiers(mapped) {
    return mapped.versions.reduce((sum, version) => sum + version.tiers.length, 0);
}
